import { useSelector } from "react-redux";
import { useQuery } from "../../utility/useQuery";
import { getEventIdFromHref } from "../../utility/";
import { Store } from "../../store";

export const useEventIdFromUrl = (): string | undefined => {
  const query = useQuery();
  const location = useSelector((state: Store) => state.router.location);

  // ref: https://github.com/balus-co-ltd/spwn/blob/a348fe6b6b4ae8f8c0a04b777a39aedec7c470a0/legacy/packages/portal/src/features/crew/useCrewStreaming.tsx#L47
  const crewStreamingEventId = query.get("eventId");
  // ref: https://github.com/balus-co-ltd/spwn/blob/a348fe6b6b4ae8f8c0a04b777a39aedec7c470a0/legacy/packages/portal/src/containers/event/EventBase.tsx#L25-L26
  const eventPageEventId = getEventIdFromHref(location.pathname, "events");

  console.debug({
    crewStreamingEventId,
    eventPageEventId,
  });

  if (crewStreamingEventId) {
    return crewStreamingEventId;
  }
  if (eventPageEventId) {
    return eventPageEventId;
  }
  return undefined;
};
